import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-default-text-input',
  template: `
    <div class="wrapper">
      <div><label for="{{id}}">{{label}}</label><i *ngIf="required" class="fas fa-asterisk center red-icon"></i></div>
      <input type="{{getType()}}" maxlength={{max}} placeholder="{{placeholder}}" id="{{id}}" [formControl]="control" autocomplete="{{autocomplete}}" (input)="propagateChange(control)" />
      <div *ngIf="getErrors()">
        <div class="errors" *ngFor="let err of getErrors()">
          <span> {{err}} </span>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./default-text-input.component.scss']
})
export class DefaultTextInputComponent implements OnInit {

  @Input() placeholder: string;
  @Input() autocomplete: string;
  @Input() id: string;
  @Input() label: string;
  @Input() control: FormControl;
  @Input() password: boolean = false;
  @Output() input: EventEmitter<FormControl>;
  required: boolean;
  @Input() max: string = '';

  constructor() {
    this.input = new EventEmitter<FormControl>();
   }

  ngOnInit() {
    this.required = this.CheckIfRequired(this.control);
  }

  getType(): string {
    return this.password ? 'password' : 'text';
  }

  getErrors() {
    if(this.control.errors && this.control.touched) {
      let errs = Object.keys(this.control.errors);
      let visibleErrs = [];
      for(var i = 0; i < errs.length; i++) {
        if(this.password && errs[i].toLowerCase() == 'required') {
          continue;
        }
        visibleErrs.push(this.CapitalizeFirstChar(errs[i]));
      }
      return visibleErrs;
    }
  }

  propagateChange(val: FormControl) {
    this.input.emit(val);
  }

  CapitalizeFirstChar(input: String) : string {
    return input.charAt(0).toLocaleUpperCase() + input.substring(1);
  }

  CheckIfRequired(input: FormControl): boolean {

    const control: AbstractControl = this.control as AbstractControl;

    if (!control) {
      return false;
    }

    if (control.validator) {
      const validator = control.validator({ value: "" } as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }

    return false;
  }


}
